import { Helmet } from 'react-helmet-async';
import ServicePage from './ServicePage';
import { useService } from '../hooks/usePublicApi';
import { serviceCategories } from '../data/services';

const staticData = serviceCategories.find((s) => s.id === 'neubau');

export default function Neubau() {
  const { service } = useService('neubau');
  const data = service || staticData;

  return (
    <>
      <Helmet>
        <title>Neubau — Innenausbau | Süd Ausbau GmbH</title>
        <meta name="description" content="Kompletter Innenausbau für Neubauprojekte in München. Von der Rohbauphase bis zum schlüsselfertigen Ergebnis — Süd Ausbau GmbH." />
        <link rel="canonical" href="https://sued-ausbau.de/neubau" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sued-ausbau.de/neubau" />
        <meta property="og:title" content="Neubau — Innenausbau | Süd Ausbau GmbH" />
        <meta property="og:description" content="Kompletter Innenausbau für Neubauprojekte in München. Von der Rohbauphase bis zum schlüsselfertigen Ergebnis — Süd Ausbau GmbH." />
        <meta property="og:image" content="https://sued-ausbau.de/og-preview.png" />
      </Helmet>
      <ServicePage data={data} />
    </>
  );
}
